import React from "react";
import Icon from "../../../Icon";
import IconCheck from "../../../../icons/IconCheck.tsx";
import IconArrow from "../../../../icons/IconArrow.tsx";

export interface CardProps {
    position?: 'start' | 'end' | 'middle';
    done: boolean;
    title: string;
    children?: React.ReactNode;
    statusIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export default function Card({position = 'middle', done, title, children, icon, statusIcon}: CardProps) {
    return <li className={`${position} ${done ? 'done' : ''}`}>
        <div className="status">
            <Icon component={statusIcon ?? done ? IconCheck : IconArrow}/>
        </div>
        <div className="procedure-card">
            <Icon component={icon}/>
            <h3 className="heading heading--montserrat">
                {title}
            </h3>
            {children}
        </div>
    </li>
}

export function CardList({children}: { children: React.ReactNode }) {
    return <ul className="selfcare-delivery-flow-timeline">
        {children}
    </ul>
}
